export default "__VITE_PUBLIC_ASSET__df1a4527__"